package one.healthium.meal_plans.data

import one.healthium.loco.asLString
import one.healthium.meal_plans.domain.MealPlanInfoModel

internal class MealPlanMapper {
    fun dtoToModel(dto: MealPlanInfoDto): MealPlanInfoModel {
        return MealPlanInfoModel(
            id = dto.id,
            name = dto.title.asLString(),
            tags = dto.tags,
        )
    }
}